import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Is this a replacement for medical treatment?',
  answer: 'No. It is a complementary tool that addresses the emotional root while you continue your standard care.'
}, {
  question: 'Do I need to be "spiritual" for this to work?',
  answer: 'Not at all. This is based on biological principles and how the brain manages extreme stress.'
}, {
  question: 'How long is the book?',
  answer: 'It is a concise, high-impact PDF manual designed for quick reference when you are in pain.'
}, {
  question: 'Does it include skin and digestive issues?',
  answer: 'Yes, it covers every major system including skin, digestion, respiratory, and musculoskeletal.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-navy-light py-20 px-6 md:px-12" data-id="element-3">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto space-y-12" data-id="element-4">
        <h2 className="text-3xl md:text-5xl font-bold text-white text-center" data-id="element-5">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-6">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 10
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-dark-navy rounded-lg overflow-hidden border border-teal-accent/20 hover:border-teal-accent/50 hover:cyan-glow transition-all" data-id="element-7">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-dark-navy-light/50 transition-colors" data-id="element-8">
                <span className="font-semibold text-lg text-white pr-4" data-id="element-9">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-teal-accent flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-10" />
              </button>
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="px-6 pb-6" data-id="element-11">
                  <p className="text-stone-400 leading-relaxed" data-id="element-12">{faq.answer}</p>
                </motion.div>}
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}